import { adminRoutes } from 'modules/admin/routes/constants';

export const adminStaffRoutes = {
  root: `${adminRoutes.root}/staff`,
  activatedUsers: `${adminRoutes.root}/staff/activated`,
  deactivatedUsers: `${adminRoutes.root}/staff/deactivated`,
};
